<template>
  <div>
    <el-row class="detail-header-wrap">
      <BaseHeader
          :title="pageTitle"
          icon="account"
          class="account-header" />
      <BaseBackButton
          :is-show="showBackButton"
          return-destination="/account" />
      <BaseDetailMoveData
          v-if="showDetailMoveDataComponent"
          :id="roleNames"
          :title="detailMoveDataTitle"
          :list-index="listIndex"
          :mode="mode"
          :array-lists="sortedList"
          :path-parameter="['uuid']"
          :can-move-data="canMoveData"
          router-path="/account/" />
    </el-row>
    <el-row>
      <el-col :span="8">
        <div class="edit-table-list">
          <div class="table-vertical">
            <div class="edit-button-wrap">
              <el-dropdown
                  v-show="showActionButtonComponent"
                  placement="bottom-start"
                  @command="actionCommand">
                <el-button size="small">
                  アクション
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu
                    slot="dropdown"
                    class="header-action-menu">
                  <el-dropdown-item
                      v-if="$isFunctionShown(define.PermissionKeys.Account.Account.Detail.EDIT)"
                      :disabled="$isFunctionDisabled(define.PermissionKeys.Account.Account.Detail.EDIT)"
                      :command="define.ACCOUNT_MODE.EDIT">
                    編集
                  </el-dropdown-item>
                  <el-dropdown-item
                      v-if="$isFunctionShown(define.PermissionKeys.Account.Account.Detail.NEW)"
                      :disabled="$isFunctionDisabled(define.PermissionKeys.Account.Account.Detail.NEW)"
                      :command="define.ACCOUNT_MODE.NEW">
                    新規
                  </el-dropdown-item>
                  <el-dropdown-item
                      v-if="$isFunctionShown(define.PermissionKeys.Account.Account.Detail.DELETE)"
                      :disabled="$isFunctionDisabled(define.PermissionKeys.Account.Account.Detail.DELETE)"
                      :command="define.ACCOUNT_MODE.DELETE">
                    削除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <BaseButton v-show="showCancelButton"
                  @click="cancel()">
                キャンセル
              </BaseButton>
              <BaseButton v-show="showSaveButton"
                  :disabled="disableSaveButton"
                  @click="save()">
                保存
              </BaseButton>
            </div>
            <BaseTableDetail
                :border="true"
                :table-set-list="accountInfo"
                :display-item="accountDetail"
                :editable="editable" />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<style scoped>
.table-vertical ::v-deep .multipleLines .is-error-msg {
  white-space: pre-line;
  margin-top: -12px;
  margin-bottom: -6px;
}
.table-vertical ::v-deep .validIps button {
  padding: 3px 3px;
  border: none;
  background-color: white;
  font-size: 12pt;
}
.table-vertical ::v-deep .validIps .delBtn > button{
  color: rgb(226, 41, 8)
}
.table-vertical ::v-deep .validIps .addBtn > button{
  color: rgb(46, 122, 36)
}
.table-vertical ::v-deep .validIps button:focus,
.table-vertical ::v-deep .validIps button:hover {
  background-color: white;
}
.table-vertical ::v-deep .validIps .flex > :first-child {
  flex-grow: 1;
  max-width: 200px;
}
</style>
<script>
import Vue from 'vue'
import _ from 'lodash'
import { mapState, mapMutations, mapGetters } from 'vuex'
import store from '@/store/index'

import * as define from '@/define'
import * as accountQuery from '@/queries/account'
import common from '@/utils/common'
import permissionRole from '@/store/pages/permissionRole'
import siteRole from '@/store/pages/siteRole'
import compare from '@/utils/compareUtils'
import * as config from '@/config'
import message from '@/utils/message'

import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import x from '@/components/mixins/mixin'
import confirmDiscardOnLeave from '@/components/mixins/confirmDiscardOnLeave'

import BaseButton from '@/components/atoms/BaseButton'
import BaseHeader from '@/components/molecules/BaseHeader'
import BaseBackButton from '@/components/molecules/BaseBackButton'
import BaseTableDetail from '@/components/molecules/BaseTableDetail'
import BaseDetailMoveData from '@/components/molecules/BaseDetailMoveData'
import detailUtil from '@/components/mixins/detailUtil'

const EDITABLE = Object.freeze({
  [define.ACCOUNT_MODE.NORMAL]: Object.freeze({}),
  [define.ACCOUNT_MODE.EDIT]: Object.freeze({ email: true, is_notice: true, type: true, siteRole: true, permissionRole: true, timezone: true, isConsole: true, validIps: false, useDefault: true }),
  [define.ACCOUNT_MODE.NEW]: Object.freeze({ account: true, password: true, email: true, is_notice: true, type: true, siteRole: true, permissionRole: true, timezone: true, isConsole: true, validIps: false, useDefault: true })
})

const returnDestination = '/account'
const returnDestinationTitle = 'CCS - アカウント一覧'

const customValidationRules = (v) => {
  // パスワードポリシーのチェック
  // password policy 取得処理は修正が必要
  v.$validator.extend('passwordPolicy', {
    getMessage: (field, rule, data) => {
      return common.getPasswordPolicyErrorMessage(data)
    },
    validate: () => {
      return common.checkPasswordPolicyResult(v.accountDetail.account, v.accountDetail.password)
    }
  })
  // パスワードと確認用パスワードの一致チェック
  v.$validator.extend('confirmPassword', {
    getMessage: () => 'パスワードが一致しません',
    validate: () => {
      return v.passwordConfirmed
    }
  })
  // IPアドレスの形式チェック
  v.$validator.extend('ipValidateCheck', {
    getMessage: () => 'アドレスの形式が不正です',
    validate: (data) => {
      const regexp = /^(([1-9]?\d|1\d{2}|2[0-4]\d|25[0-5])\.){3}([1-9]?\d|1\d{2}|2[0-4]\d|25[0-5])(\/([1-2]?\d|3[0-2]))?$/
      if (!regexp.test(data)) {
        return false
      }
      return true
    }
  })
  // IPアドレスの重複チェック
  v.$validator.extend('ipDuplicateCheck', {
    getMessage: () => '同じアドレスが存在します',
    validate: (data) => {
      if (v.accountDetail.validIps.split(',').filter((val, key) => { return val === data }).length > 1) {
        return false
      }

      return true
    }
  })
  // IPアドレスの文字数チェック
  v.$validator.extend('ipLengthCheck', {
    getMessage: () => 'IPアドレスが設定可能上限を超えています',
    validate: () => {
      if (v.accountDetail.validIps.length > 500) {
        return false
      }
      return true
    }
  })
}

export default {
  name: 'AccountDetail',
  components: {
    BaseButton,
    BaseHeader,
    BaseBackButton,
    BaseTableDetail,
    BaseDetailMoveData
  },
  mixins: [ x, confirmDiscardOnLeave, detailUtil ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      accountDetail: {},
      originData: {},
      siteRoleList: [],
      accountTypeOptionsList: [],
      accountTypeOptionsAllList: [],
      permissionRoleList: [],
      isChanged: false,
      passwordConfirmed: true,
      reservedTransition: false,
      canMoveData: false
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      listIndex: (state) => state.Account.listIndex,
      size: (state) => state.Account.size,
      mode: (state) => state.Account.mode,
      siteRoleOptions: (state) => state.SiteRole.siteRoleOptions,
      permissionRoleOptions: (state) => state.PermissionRole.permissionRoleOptions,
      accountType: (state) => state.accountType,
      isConsoleDefaultValue: (state) => Number(_.get(state, 'serviceSiteConfigs.m_account.default_config.is_console.v.0', 1))
    }),
    ...mapGetters({
      isSystemAccount: 'isSystemAccount',
      getAccountTypeOptions: 'getAccountTypeOptions',
      getAccountTypePower: 'getAccountTypePower'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    storePath () {
      return 'Account'
    },
    sortedList () {
      return this.$store.getters['sortedList'](this.storePath, this.sortCondition('accountList'))
    },
    pageTitle () {
      return this.mode === define.ACCOUNT_MODE.NEW
        ? 'アカウント登録'
        : 'アカウント詳細'
    },
    showDetailMoveDataComponent () {
      return this.mode !== define.ACCOUNT_MODE.NEW
    },
    showActionButtonComponent () {
      return (this.showActionButton &&
             (this.$isFunctionShown(define.PermissionKeys.Account.Account.Detail.EDIT) ||
              this.$isFunctionShown(define.PermissionKeys.Account.Account.Detail.NEW) ||
              this.$isFunctionShown(define.PermissionKeys.Account.Account.Detail.DELETE)))
    },
    detailMoveDataTitle () {
      return this.accountDetail.account
    },
    /**
     * サイトロール名と権限ロール名を返却する.
     * @returns '[サイトロール名] : [権限ロール名]'
     */
    roleNames () {
      let roles = []
      if (this.$isFunctionShown(define.PermissionKeys.Account.Account.Detail.SITE_ROLE_UUID)) {
        roles.push(this.accountDetail.siteRole)
      }
      if (this.$isFunctionShown(define.PermissionKeys.Account.Account.Detail.PERMISSION_ROLE_UUID)) {
        roles.push(this.accountDetail.permissionRole)
      }
      return _.chain(roles)
        .filter(val => val && val.name)
        .map('name')
        .join(' : ')
        .value()
    },
    accountInfo () {
      return [
        {
          label: 'アカウント',
          properties: [
            {
              path: 'account', type: 'String', editableId: 'account', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', validateAs: 'アカウント'
            }
          ]
        },
        {
          label: 'パスワード',
          properties: [
            {
              path: 'password', type: 'String', editableId: 'password', elementType: ELEMENT_TYPE.INPUT, password: true,
              validateRule: 'required|max:50|passwordPolicy', validateAs: 'パスワード', class: 'multipleLines', autoComplete: 'new-password'
            },
            {
              path: 'passwordConfirm', type: 'String', editableId: 'password', elementType: ELEMENT_TYPE.INPUT, password: true,
              validateRule: 'required|max:50|confirmPassword', validateAs: 'パスワード', autoComplete: 'new-password'
            }
          ],
          horizontal: true, isShow: this.showPassword
        },
        {
          label: 'メールアドレス',
          properties: [
            {
              path: 'email', type: 'String', editableId: 'email', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:256|email', validateAs: 'メールアドレス'
            }
          ]
        },
        {
          label: '変更通知受信',
          properties: [
            {
              path: 'isNotice', type: 'Number', editableId: 'is_notice',
              elementType: ELEMENT_TYPE.RADIO_BUTTON,
              selectCode: () => {
                return [
                  { code: 0, name: '通知しない' },
                  { code: 1, name: '通知する' }
                ]
              },
              funcId: define.PermissionKeys.Account.Account.Detail.IS_NOTICE
            }
          ],
          horizontal: true, isShow: this.showIsNotice
        },
        {
          label: '権限タイプ',
          properties: [
            {
              type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX, path: 'type',
              editableId: 'type', validateRule: 'required', validateAs: '権限タイプ',
              selectCode: () => {
                if (this.isSystemAccount()) { return this.selectAccountTypeOptionsALL() } else { return this.selectAccountTypeOptions() }
              },
              codeName: (code) => (this.selectAccountTypeOptionsALL().find(element => code === element.code) || {}).name,
              // 新規登録時は必須項目であるため編集可とする
              editableCondition: () => (this.mode === define.ACCOUNT_MODE.NEW || !this.$isFunctionDisabled(define.PermissionKeys.Account.Account.Detail.TYPE))
            }
          ],
          // 新規登録時は必須項目であるため、表示する
          isShow: () => (this.mode === define.ACCOUNT_MODE.NEW || this.$isFunctionShown(define.PermissionKeys.Account.Account.Detail.TYPE))
        },
        {
          label: 'サイトロール',
          properties: this.$isFunctionDisabled(define.PermissionKeys.Account.SiteRole.DETAIL) || this.mode !== define.ACCOUNT_MODE.NORMAL
            ? [
              { // サイトロール詳細へのリンクなし
                type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX, path: 'siteRole.uuid',
                editableId: 'siteRole', selectCode: this.selectSiteRoleList, clearable: true,
                codeName: (code) => (this.selectSiteRoleList().find(element => code === element.code) || {}).name,
                funcId: define.PermissionKeys.Account.Account.Detail.SITE_ROLE_UUID
              }
            ]
            : [
              { // サイトロール詳細へのリンクあり
                type: 'String', path: 'siteRole.uuid', linkKey: 'siteRole.uuid',
                linkPath: '/siterole/', elementType: ELEMENT_TYPE.LINK,
                editableId: 'siteRole', selectCode: this.selectSiteRoleList, clearable: true,
                codeName: (code) => (this.selectSiteRoleList().find(element => code === element.code) || {}).name,
                funcId: define.PermissionKeys.Account.Account.Detail.SITE_ROLE_UUID,
                onLinkClick: (key, keyPath) => {
                  this.$_mixin_onLinkClick(-1, 'SiteRole')
                }
              }
            ]
        },
        {
          label: '権限ロール',
          properties: this.$isFunctionDisabled(define.PermissionKeys.Account.PermissionRole.DETAIL) || this.mode !== define.ACCOUNT_MODE.NORMAL
            ? [
              { // 権限ロール詳細へのリンクなし
                type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX, path: 'permissionRole.uuid',
                editableId: 'permissionRole', selectCode: this.selectPermissionRoleList, clearable: true,
                codeName: (code) => (this.selectPermissionRoleList().find(element => code === element.code) || {}).name,
                funcId: define.PermissionKeys.Account.Account.Detail.PERMISSION_ROLE_UUID
              }
            ]
            : [
              { // 権限ロール詳細へのリンクあり
                type: 'String', path: 'permissionRole.uuid', linkKey: 'permissionRole.uuid',
                linkPath: '/permissionrole/', elementType: ELEMENT_TYPE.LINK,
                editableId: 'permissionRole', selectCode: this.selectPermissionRoleList, clearable: true,
                codeName: (code) => (this.selectPermissionRoleList().find(element => code === element.code) || {}).name,
                funcId: define.PermissionKeys.Account.Account.Detail.PERMISSION_ROLE_UUID,
                onLinkClick: (key, keyPath) => {
                  this.$_mixin_onLinkClick(-1, 'PermissionRole')
                }
              }
            ]
        },
        {
          label: 'タイムゾーン',
          properties: [
            {
              type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX, path: 'timezone',
              editableId: 'timezone', filterable: true, selectCode: this.timezoneList,
              codeName: (code) => (this.timezoneList().find(element => code === element.code) || {}).name,
              funcId: define.PermissionKeys.Account.Account.Detail.TIMEZONE
            }
          ]
        },
        {
          label: 'コンソール接続有無',
          properties: [
            {
              type: 'String', elementType: ELEMENT_TYPE.CHECK_BOX, path: 'isConsole',
              editableId: 'isConsole', funcId: define.PermissionKeys.Account.Account.Detail.IS_CONSOLE
            }
          ]
        },
        {
          id: 'validIps',
          label: '許可IP',
          properties: [
            {
              type: 'String', elementType: ELEMENT_TYPE.CELL,
              properties: this.validIpsObjData,
              class: 'validIps',
              funcId: define.PermissionKeys.Account.Account.Detail.VALID_IPS
            }
          ]
        },
        {
          label: '',
          properties: [
            {
              path: 'useDefault',
              type: 'String',
              editableId: 'useDefault',
              elementType: ELEMENT_TYPE.CHECK_BOX,
              label: '許可IP規定値を利用する',
              single: true
            }
          ],
          isShow: this.showUseDefault
        }
      ]
    },
    showBackButton () {
      return this.mode === define.ACCOUNT_MODE.NORMAL && !this.$isFunctionDisabled(define.PermissionKeys.Account.Account.LIST)
    },
    showActionButton () {
      return this.mode === define.ACCOUNT_MODE.NORMAL
    },
    showSaveButton () {
      return this.mode !== define.ACCOUNT_MODE.NORMAL
    },
    disableSaveButton () {
      return !this.isChanged
    },
    showCancelButton () {
      return this.mode !== define.ACCOUNT_MODE.NORMAL
    },
    editable () {
      return EDITABLE[this.mode]
    },
    editableValidIps () {
      // システム権限の場合、または管理者権限で権限の強さが対象より強い場合は編集可能
      return (this.isSystemAccount() || (this.accountType === 2 && (this.getAccountTypePower(this.accountType) || 999) <= (this.getAccountTypePower(this.accountDetail.type) || 0))) && this.mode !== define.ACCOUNT_MODE.NORMAL
    },
    validIpsObjData () {
      let objData = []
      if (this.accountDetail.validIps != null) {
        const Ips = this.accountDetail.validIps.split(',')
        Ips.forEach((validIps) => {
          const index = objData.length
          let propertiesData = [{
            id: 'validIpsTxt', type: 'String', elementType: ELEMENT_TYPE.INPUT, path: 'validIps',
            validateScope: 'validIps', displayItem: { validIps }, validateRule: 'ipValidateCheck|ipDuplicateCheck|ipLengthCheck',
            change: (event) => { this.onChangeValidIps(event, index) },
            editable: true,
            editableCondition: () => this.editableValidIps
          }]

          // 行削除用ボタン
          if (this.editableValidIps) {
            propertiesData.push({
              type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'delBtn',
              icon: 'fas fa-times-circle', click: (event) => { this.onClickIPDelBtn(index) }
            })
          }

          // 追加ボタン（新規登録・編集時に使用可能。IPアドレスの最終行に表示）
          if (this.editableValidIps && Ips.length === index + 1) {
            propertiesData.push({
              id: 'addBtn',
              type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'addBtn',
              icon: 'fas fa-plus-circle', size: 'small', click: this.onClickIPAddBtn
            })
          }

          objData.push({
            // カスタムタイプのセルを指定
            type: 'String', elementType: ELEMENT_TYPE.CELL,
            properties: propertiesData,
            index: index,
            horizontal: true
          })
        })
      } else {
        // 追加ボタン（新規登録・編集時に使用可能。IPアドレスが1つも存在しないとき下部に表示）
        if (this.editableValidIps) {
          objData.push({
            id: 'addBtn',
            type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'addBtn',
            icon: 'fas fa-plus-circle', size: 'small', click: this.onClickIPAddBtn,
            disabled: (this.showUseDefault && (this.accountDetail.useDefault === 1))
          })
        }
      }

      return objData
    }
  },
  watch: {
    accountDetail: {
      handler: function (val, oldVal) {
        this.isChanged = this.$_ConfirmDiscardOnLeave_isChanged()
      },
      deep: true
    },
    mode (val) {
      // 既に遷移予定である場合、制御不要
      if (!this.reservedTransition) {
        const route = this.$route
        if (val === define.ACCOUNT_MODE.NORMAL &&
          (route.params && route.params.id === '0')) {
          this.$router.push({ path: returnDestination })
        }
        // ページタイトルの再設定
        document.title = `CCS - ${this.pageTitle}`
      }
    }
  },
  async created () {
    // ページタイトルの設定
    document.title = `CCS - ${this.pageTitle}`
    window.addEventListener('beforeunload', this.onBeforeUnload)
    this.$loadingService.show()
    try {
      // カスタムバリデーションルールを追加
      customValidationRules(this)

      // サイトロールと権限ロールの選択肢取得(未取得の時実施される)
      await Promise.all([
        siteRole.getSiteRoleOptions(),
        permissionRole.getPermissionRoleOptions()
      ])

      // リストの選択肢の設定
      this.accountTypeOptionsList = this.getAccountTypeOptions(this.accountType, this.accountType === 2)
      this.accountTypeOptionsAllList = this.getAccountTypeOptions()
      this.siteRoleList = this.siteRoleOptions
      this.permissionRoleList = this.permissionRoleOptions

      // 詳細データ取得
      await this.getDetailData()

      // 新規モードの場合
      if (this.mode === define.ACCOUNT_MODE.NEW) {
        this.originData = _.cloneDeep(this.accountDetail)
        this.$_ConfirmDiscardOnLeave_watchStart(this.accountDetail, 'アカウント登録を中止しますか？')
      }
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  },
  beforeRouteEnter (to, from, next) {
    // [beforeRouteEnter]ではvueコンポーネントの生成が未完であるため、「this.$store」で呼び出しができない。
    // そのため、storeのあるファイルをImportし、直接参照している。
    if (to.params && to.params.id === '0' && store.state.Account.mode !== define.ACCOUNT_MODE.NEW) {
      // 履歴の操作により、入ってきたとき、storeが正しくないので編集
      store.dispatch({ type: 'set', states: { 'Account/mode': define.ACCOUNT_MODE.NEW } })
    } else if (to.params && to.params.id !== '0' && store.state.Account.mode !== define.ACCOUNT_MODE.NORMAL) {
      next(vm => {
        vm.updateMode(define.ACCOUNT_MODE.NORMAL)
      })
      return
    }

    next()
  },
  async beforeRouteUpdate (to, from, next) {
    // 一覧からの呼び出しの新規作成完了後
    if (from.params && from.params.id === '0') {
      // 戻る等でいきなり新規作成とならないように履歴を修正
      document.title = returnDestinationTitle
      history.replaceState(null, null, returnDestination)
    }
    // ページ送りにより変更した対象アカウントのデータ取得（ページ送り時のモードは通常モードに制御されているため、初期化不要）
    next()
    await this.getDetailData()
  },
  beforeRouteLeave (to, from, next) {
    // 別ページへ移動する場合、modeを初期化する.
    this.reservedTransition = true
    this.updateMode(define.ACCOUNT_MODE.NORMAL)

    next()
  },
  methods: {
    ...mapMutations('Account', {
      updateListItem: 'update',
      deleteListItem: 'delete'
    }),
    onBeforeUnload (event) {
      if (this.isChanged) {
        // 変更有の場合、再読み込み確認ダイアログを表示する.
        event.returnValue = 'changed'
      }
    },

    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case define.ACCOUNT_MODE.EDIT:
          this.edit()
          break
        case define.ACCOUNT_MODE.NEW:
          this.addAccount()
          break
        case define.ACCOUNT_MODE.DELETE:
          this.deleteAccount()
          break
        default: {}
      }
    },

    edit () {
      // 対象データの権限が自身の権限の強さより弱いときのみ使用可能 管理者権限同士は使用可能
      if (!this.isSystemAccount() && (this.getAccountTypePower(this.accountDetail.type) || 0) <= (this.getAccountTypePower(this.accountType) || 999) &&
          !(this.accountDetail.type === 2 && this.accountType === 2)) {
        this.$notify.error(message.MSG_522())
        return
      }

      this.updateMode(define.ACCOUNT_MODE.EDIT)
      this.originData = _.cloneDeep(this.accountDetail)
      this.$_ConfirmDiscardOnLeave_watchStart(this.accountDetail)
    },
    async addAccount () {
      this.updateMode(define.ACCOUNT_MODE.NEW)
      await this.getDetailData()
      this.originData = _.cloneDeep(this.accountDetail)
      this.$_ConfirmDiscardOnLeave_watchStart(this.accountDetail, 'アカウント登録を中止しますか？')
    },
    deleteAccount () {
      // 対象データの権限が自身の権限の強さが弱いときのみ使用可能 管理者権限同士は使用可能
      if (!this.isSystemAccount() && (this.getAccountTypePower(this.accountDetail.type) || 0) <= (this.getAccountTypePower(this.accountType) || 999) &&
          !(this.accountDetail.type === 2 && this.accountType === 2)) {
        this.$notify.error(message.MSG_522())
        return
      }
      this.$confirm('アカウントを削除しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          await this.deleteAccountApi()
          this.deleteListItem(this.accountDetail.uuid)
          this.$notify.success('アカウントを削除しました。')
          this.updateMode(define.ACCOUNT_MODE.NORMAL)
          this.$router.push({ path: returnDestination })
        } catch (error) {
          const data = _.get(error, 'response.data')
          if (data == null) {
            common.addError(error, { msg: message.MSG_502() })
          } else {
            common.addError(error, { msg: message.MSG_515() })
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {})
    },
    async save () {
      // チェック処理
      this.passwordConfirmed = this.accountDetail.password === this.accountDetail.passwordConfirm
      if (!await this.$validator.validate()) {
        return
      }
      if (this.mode === define.ACCOUNT_MODE.NEW) {
        try {
          // 同一アカウント名チェック処理
          this.$loadingService.show()
          const query = common.addGraphQlCondition(accountQuery.GRAPH_QL_QUERY_ACCOUNTS_BY_ACCOUNT_NAME, { account: this.accountDetail.account })
          const res = await common.postGraphQl(query)
          if (res.data.data.accountsByAccountName.length > 0) {
            this.$notify.error(message.MSG_525())
            return
          }
        } catch (error) {
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }

      this.$confirm('保存しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          // IPアドレスの不要な空行の削除
          this.accountDetail.validIps = this.accountDetail.validIps ? this.accountDetail.validIps.split(/[\s,]+/).filter((val) => val).join(',') : this.accountDetail.validIps
          this.$loadingService.show()
          const res = await this.updateOrInsertAccountApi()
          this.$_ConfirmDiscardOnLeave_watchEnd()
          this.isChanged = false
          if (this.mode === define.ACCOUNT_MODE.NEW) {
            this.reservedTransition = true
            this.updateMode(define.ACCOUNT_MODE.NORMAL)
            this.$router.push({ path: `/account/${res.data.uuid}` })
          } else {
            this.updateMode(define.ACCOUNT_MODE.NORMAL)
            await this.getDetailData(true)
          }
          this.$notify.success('保存しました。')
        } catch (error) {
          const data = _.get(error, 'response.data')
          if (data == null) {
            common.addError(error, { msg: message.MSG_502() })
          } else if (this.hasLastUpdatedError(error)) {
            common.addError(error, { msg: message.MSG_528() })
          } else {
            if (this.mode === define.ACCOUNT_MODE.NEW) {
              common.addError(error, { msg: message.MSG_509() })
            } else {
              common.addError(error, { msg: message.MSG_510() })
            }
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {
        this.$notify.info('キャンセルしました。')
      })
    },
    cancel () {
      const cancelEdit = () => {
        const modeWhenEntered = this.mode
        this.updateMode(define.ACCOUNT_MODE.NORMAL)
        // 新規作成から戻ってきたとき、詳細データの再読み込みを行う
        if (modeWhenEntered === define.ACCOUNT_MODE.NEW) {
          const route = this.$route
          if (!(route.params && route.params.id === '0')) {
            this.getDetailData()
          }
        }
        this.$_ConfirmDiscardOnLeave_watchEnd()
        this.isChanged = false
      }
      if (!this.isChanged) {
        cancelEdit()
        return
      }
      this.$confirm(
        this.mode === define.ACCOUNT_MODE.NEW
          ? 'アカウント登録を中止しますか？'
          : '変更を破棄しますか？',
        define.MESSAGE_TITLE,
        {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }
      ).then(() => {
        this.accountDetail = _.cloneDeep(this.originData)
        cancelEdit()
      }).catch(e => e)
    },
    /**
     * アカウント詳細情報を取得します。
     * @param {Boolean} [updateList=false] 一覧の情報を更新する場合、true
     */
    async getDetailData (updateList = false) {
      try {
        this.$loadingService.show()
        if (this.mode !== define.ACCOUNT_MODE.NEW) {
          const query = common.addGraphQlCondition(accountQuery.GRAPH_QL_QUERY_ACCOUNT_DETAIL, { uuid: this.$route.params.id })
          const res = await common.postGraphQl(query)

          // 結果が null の場合
          if (res.data.data.account == null) {
            this.$notify.error({
              message: 'データを取得できませんでした。'
            })
            return
          }

          // listIndexの更新
          this.$_detailUtil_onGetDetailData((element) => element.uuid === this.$route.params.id)

          this.accountDetail = res.data.data.account
          // IPが空文字の場合、行なしとして扱うように変換する。
          if (!this.accountDetail.validIps) {
            this.accountDetail.validIps = null
          }
        } else {
          this.accountDetail = {
            account: '',
            password: '',
            email: '',
            isNotice: 0,
            passwordConfirm: '',
            type: '',
            siteRole: { uuid: undefined },
            permissionRole: { uuid: undefined },
            timezone: '',
            validIps: null,
            useDefault: 0,
            isConsole: this.isConsoleDefaultValue
          }
        }
        this.originData = _.cloneDeep(this.accountDetail)

        if (updateList) {
          this.updateListItem(this.accountDetail)
        }
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    /**
     * accountDetail からアカウント登録APIのリクエストパラメータを作成する.
     */
    buildRequestForInsert () {
      let requestBody = {
        account: this.accountDetail.account,
        password: this.accountDetail.password,
        email: this.accountDetail.email,
        type: this.accountDetail.type
      }

      // 管理者権限以外は変更通知無効にする
      if (!this.$isFunctionDisabled(define.PermissionKeys.Account.Account.Detail.IS_NOTICE)) {
        requestBody.isNotice = this.accountDetail.isNotice
        if (this.accountDetail.type !== 2) {
          requestBody.isNotice = 0
        }
      }

      if (this.accountDetail.siteRole) {
        requestBody.siteRoleUuid = this.accountDetail.siteRole.uuid
      }
      if (this.accountDetail.permissionRole) {
        requestBody.authRoleUuid = this.accountDetail.permissionRole.uuid
      }
      if (this.accountDetail.timezone) {
        requestBody.timezone = this.accountDetail.timezone
      }
      if (this.$isFunctionShown(define.PermissionKeys.Account.Account.Detail.IS_CONSOLE)) {
        requestBody.isConsole = this.accountDetail.isConsole
      }
      // SYSTEMまたはADMIN権限のアカウントで、
      // 値が入力されている、またはデフォルト値を使用しない場合のみIPをAPIに渡す
      if (this.isSystemAccount() || this.accountType === 2) {
        if (this.accountDetail.validIps != null || this.accountDetail.useDefault !== 1) {
          requestBody.validIps = this.accountDetail.validIps || ''
        }
      }
      return requestBody
    },
    /**
     * accountDetail からアカウント更新APIのリクエストパラメータを作成する.
     * originDataとの差分のみ戻り値とする.
     */
    buildRequestForUpdate () {
      const diff = compare.diff(this.originData, this.accountDetail)
      let requestBody = _.pick(diff, ['email', 'isNotice', 'type', 'timezone', 'isConsole'])
      if (diff.siteRole) {
        requestBody.siteRoleUuid = diff.siteRole.uuid || null
      }
      if (diff.permissionRole) {
        requestBody.authRoleUuid = diff.permissionRole.uuid || null
      }
      // 管理者権限以外は変更通知無効にする
      if (this.accountDetail.type !== 2) {
        // 変更通知受信の設定が可能の場合は変更通知無効にする
        if (!this.$isFunctionDisabled(define.PermissionKeys.Account.Account.Detail.IS_NOTICE)) {
          requestBody.isNotice = 0
        }
      }
      // SYSTEMまたはADMIN権限のアカウントであった場合のみ、IPを渡す(値nullがあり得るので「undefined」でないことが条件となる)
      if ((this.isSystemAccount() || this.accountType === 2) && typeof diff.validIps !== 'undefined') {
        requestBody.validIps = this.accountDetail.validIps
      }
      return requestBody
    },
    /**
     * アカウント登録 API またはアカウント更新 APIを呼び出す
     */
    async updateOrInsertAccountApi () {
      const heads = { 'X-CCS-Last-Updated-At': this.accountDetail.updatedAt }
      let url
      let method
      let data
      if (this.mode === define.ACCOUNT_MODE.NEW) {
        url = config.ACCOUNT_URL
        method = 'post'
        data = this.buildRequestForInsert()
      } else {
        url = config.ACCOUNT_URL + '/' + this.accountDetail.uuid
        method = 'put'
        data = this.buildRequestForUpdate()
      }
      const response = await common.apiAxios(url, { method, data, heads })

      return response
    },
    async deleteAccountApi () {
      const url = config.ACCOUNT_URL + '/' + this.accountDetail.uuid
      const method = 'delete'
      const response = await common.apiAxios(url, { method })
      return response
    },
    hasLastUpdatedError (error) {
      const code = _.get(error, 'response.data.code')
      if (code !== 400) {
        return false
      }
      return _.chain(error)
        .get('response.data.errors')
        .find(val => val.location === 'lastUpdatedAt' && val.reason === 'invalid')
        .value() != null
    },
    showPassword () {
      return this.mode === define.ACCOUNT_MODE.NEW
    },
    showIsNotice () {
      return this.accountDetail.type === 2 && this.$isFunctionShown(define.PermissionKeys.Account.Account.Detail.IS_NOTICE)
    },
    showUseDefault () {
      // システム権限の場合、または管理者権限
      return ((this.isSystemAccount() || this.accountType === 2) && (this.mode === define.ACCOUNT_MODE.NEW) && (this.accountDetail.validIps == null))
    },
    selectAccountTypeOptions () {
      return this.accountTypeOptionsList
    },
    selectAccountTypeOptionsALL () {
      return this.accountTypeOptionsAllList
    },
    selectSiteRoleList () {
      return _.map(this.siteRoleList, (val) => ({ code: val.uuid, name: val.name }))
    },
    selectPermissionRoleList () {
      return _.map(this.permissionRoleList, (val) => ({ code: val.uuid, name: val.name }))
    },
    timezoneList () {
      return _.map(Vue.moment.tz.names(), (val) => ({ code: val, name: val }))
    },
    updateMode (mode) {
      this.$store.commit({
        type: 'set',
        states: {
          'Account/mode': mode
        }
      })
    },
    onClickIPDelBtn (index) {
      let Ips = this.accountDetail.validIps.split(',')
      Ips = Ips.filter((val, key) => {
        return key !== index
      })
      this.accountDetail.validIps = Ips.length === 0 ? null : Ips.join(',')
      // 行番号が変わり、メッセージの出力箇所が不正となるため、再度全行バリデーションチェックを行う。
      this.ipValidationCheck()
    },
    onClickIPAddBtn () {
      if (this.accountDetail.validIps != null) {
        // すでに行があるとき
        this.accountDetail.validIps += ','
      } else {
        // 1行もないとき
        this.accountDetail.validIps = ''
      }
    },
    onChangeValidIps (event, index) {
      // 現在の値更新
      let newIps = []
      const ipRows = this.accountInfo.find((obj) => { return obj.id === 'validIps' }).properties[0].properties
      Object.keys(ipRows).forEach((key) => {
        if (key === String(index)) {
          newIps.push(event.replace(/,/g, ''))
        } else {
          if (ipRows[key].id !== 'addBtn') {
            newIps.push(ipRows[key].properties.find((obj) => { return obj.id === 'validIpsTxt' }).displayItem.validIps.replace(/,/g, ''))
          }
        }
      })
      this.accountDetail.validIps = newIps.join(',')

      // 値変更により重複チェックが解消されたとき、もう一方のエラーを解除する必要があるため、全行バリデーションチェックを行う。
      this.ipValidationCheck()
    },
    ipValidationCheck () {
      setTimeout(() => {
        this.$validator.validate('validIps.*')
      })
    }
  }
}
</script>
